import { useEffect, useState } from "react";

// Next merch drop date — change this when you set a new drop
const NEXT_DROP = new Date("2026-11-15T12:00:00-06:00");

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = NEXT_DROP.getTime() - now;

  if (diff <= 0) {
    return (
      <div data-testid="drop-countdown" className="flex items-center gap-3 border border-[#ff1053]/50 bg-[#ff1053]/10 rounded-full px-6 py-3">
        <span className="w-2 h-2 rounded-full bg-[#ff1053] animate-pulse" />
        <span className="text-[10px] uppercase tracking-[0.3em] text-white">The Drop Is Live</span>
      </div>
    );
  }

  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);

  const cells = [
    [d, "Days"],
    [h, "Hrs"],
    [m, "Min"],
    [s, "Sec"],
  ];

  return (
    <div data-testid="drop-countdown" className="flex items-center gap-4 border border-white/15 glass-panel rounded-full px-6 py-3">
      <span className="text-[9px] uppercase tracking-[0.3em] text-[#ff1053]">Next Drop</span>
      <div className="flex items-center gap-3">
        {cells.map(([v, label], i) => (
          <span key={label} className="flex items-center gap-3">
            <span className="text-center">
              <span className="block font-unbounded text-sm leading-none">{pad(v)}</span>
              <span className="block text-[8px] uppercase tracking-[0.2em] text-white/40 mt-1">{label}</span>
            </span>
            {i < cells.length - 1 && <span className="text-white/25 font-unbounded text-xs pb-3">:</span>}
          </span>
        ))}
      </div>
    </div>
  );
}
